import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import { color, motion } from "framer-motion"
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { getPresentationInit } from '../utils/api-services/topic';
import './components/presentation_styles.css';
import { displayTopicUtil } from '../utils/topicUtils';
import PresentationHeader from './components/PresentationHeader';

function PresentationStart() {

    const [topic, setTopic] = useState(null);
    const [loading, setLoading] = useState(false);
    const [starting, setStarting] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const { code } = useParams();

    useEffect(()=>{
        loadTopic();
    }, []);

    function loadTopic(){
        setLoading(true);
        axios({
            method: 'get',
            url: API_URL + `topic/topic_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setTopic(obj.Data);
            }
            setLoading(false);
        });
    }

    const start = async () => {
        setStarting(true);
        const startComp = await getPresentationInit(code);
        if(startComp != null){
            setStarting(false);
            window.location = `/topic/presentation/${topic.Slug}/${startComp.Slug}?mode=preview`;
        }
    }

    const styles = {
        page:{
            background: '#fff',
            marginBottom: 60,
            width: width,
            overflow: 'hidden'
        },
        body:{
            marginTop: 30,
        },
        presLabel:{
            color: '#999',
            marginBottom: 20,
            fontSize: 24
        },
        loading:{
            paddingTop:100
        },
    }

    if(loading){
        return (
            <div className='container'> 
                <div style = {styles.loading}>
                    Loading ...
                </div>
            </div>
        )
    }
    else if(topic){
        return (
            <div style={styles.page}>
                <PresentationHeader />
                <div className='container  topic-styles'>
                    <div>{displayTopicUtil(topic, start)}</div>
                </div>
            </div>
        )
    }
    
}

export default PresentationStart;